import { render, staticRenderFns } from "./MondialLogo.vue?vue&type=template&id=605b7fd7&scoped=true&"
import script from "./MondialLogo.vue?vue&type=script&lang=js&"
export * from "./MondialLogo.vue?vue&type=script&lang=js&"
import style0 from "./MondialLogo.vue?vue&type=style&index=0&id=605b7fd7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605b7fd7",
  null
  
)

export default component.exports